import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    visible: {
      type: Boolean,
      default: false
    }
    
  },
  watch: {
    visible: {
      handler(val) {
        this.show = val
        console.log('handler', val)
        if (this.show) {
          this.$nextTick(() => {
            this.initColorPicker()
          })
        }
      },
      immediate: true
    }
  }
})
export default class ColorPicker extends Vue {
  show = false
  colorList = []
  // 当前选择颜色
  currentColor = ''
  // 按钮文字颜色
  btnTextColor = '#ffffff'
  colorPicker = null
  /**
   * 初始化颜色选择器
   */
  initColorPicker() {
    console.log('initColorPicker', this.$refs)
    if (!this.$refs.colorPickerRef ||  this.colorPicker) return
    
    const width = (this.$refs.colorPickerRef as HTMLElement).clientWidth - 32
    this.colorPicker = new window.iro.ColorPicker("#stylepicker", {
      handleSvg:'#handle',//手柄
      layout: [
        { 
          component: window.iro.ui.Box,
          options: {
            padding: 0,
            width
          }
        },
        { 
          component: window.iro.ui.Slider,
          options: {
            sliderType: 'hue',
            sliderSize: 16,
            borderColor: '#ffffff',
            width
          }
        },
      ],
    })
    this.colorPicker.on('color:change', (color) => {
      //将当前颜色记录为十六进制字符串
      console.log('颜色', color);
      this.$nextTick(() => {
        this.currentColor = color.hexString
        this.btnTextColor = this.ColorReverse(color.hexString)
      })
     
    })
    this.colorPicker.color.hsl = { h: 180, s: 100, l: 50 };
    for (let index = 0; index < 6; index++) {
      this.colorList.push({
        id: index,
        color: ''
      })
    }
  }
  goBack() {
    this.closePopup()
  }
  /**
   * 添加颜色
   */
  addColor() {
    if (!this.currentColor) return
    const index = this.colorList.findIndex(item => item.color === this.currentColor)
    if (index !== -1) return
    const colorInfo = this.colorList.find(item => !item.color)
    if (colorInfo) {
      this.$set(colorInfo, 'color', this.currentColor)
      this.$emit('add-color', this.currentColor)
    }
  }
  /**
   * 颜色取反
   */
  ColorReverse(oldColorValue: string){
    const _oldColorValue: any = "0x" + oldColorValue.replace(/#/g,"")
    const str="000000" + (0xFFFFFF - _oldColorValue).toString(16)
    return '#' + str.substring(str.length-6,str.length)
  }
  closePopup() {
    this.$emit('close')
    this.show = false
  }
}